<template>
  <div v-if="courseData" id="course" class="pb-5">
    <div
      class="cover-photo"
      :style="{
        'background-image': `url(${courseData.imgSrc ||
          'https://www.gstatic.com/mobilesdk/180326_mobilesdk/discoverycards/experiments.png'})`
      }"
    >
      <div class="content">
        <p>{{ courseData.category.toUpperCase() }}</p>
        <h1>{{ courseData.name }}</h1>
      </div>
    </div>
    <div class="container pt-5">
      <div class="jumbotron">
        <p class="lead">
          {{ courseData.description }}
        </p>
        <hr class="my-4" />
        <ul class="list-group">
          <li class="list-group-item active">Meet Times</li>
          <li
            v-for="meetingTime in courseData.meetTimes"
            :key="meetingTime"
            class="list-group-item"
          >
            {{ meetingTime }}
          </li>
        </ul>
        <hr class="my-4" />
        <p class="lead">Age Rating: {{ courseData.minAge }}+ years old</p>
        <hr class="my-4" />
        <ul class="list-group">
          <li class="list-group-item active">Meeting Links</li>
          <li
            v-for="meetingLink in courseData.meetingLinks"
            :key="meetingLink"
            class="list-group-item"
          >
            <a :href="meetingLink" target="_blank">{{ meetingLink }}</a>
          </li>
        </ul>
      </div>
   
        <form class="hidden-on-mobile group">
          <input
            class="left-group"
            type="text"
            v-model="searchItem"
            placeholder="What do you want to learn?"
/>
          <button type="button" v-on:click="item" class="right-group">
            Search
          </button>
        </form>
        <p>{{ searchItem }}</p>
        <div class="info" v-if="videos">
          <h1>{{ videos[0].snippet.title }}</h1>
          <p>{{ videos[0].snippet.description }}</p>
          <img v-bind:src="videos[0].snippet.thumbnails.medium.url" />
          <a v-bind:href="'https://www.youtube.com/watch?v=' + videos[0].id.videoId"
            >Watch Video</a>
            </div>
    </div>
    
  </div>
</template>

<script>
import db from '@/components/firebaseInit'

import Search from '../store/search'
export default {
  name: 'Course',
  data() {
    return {
      courseData: null,
       videos: null,
      searchItem: null
    }
  },
  methods: {
    fetchData() {
      db.collection('courses')
        .doc(this.$route.params.id)
        .get()
        .then(snapshot => {
          if (!snapshot.exists) return
          this.courseData = snapshot.data()
        })
    },
    item() {
      Search(
        {
          apiKey: 'AIzaSyBbPKr0P_iy-ybWh0Aq3YJhHWFTrJp1ntw',
          term: this.searchItem
        },
        response => (this.videos = response)
      )
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    $route: 'fetchData'
  }
}


</script>

<style lang="scss" scoped>
.cover-photo {
  width: 100vw;
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  background-attachment: scroll;
  background-position: 50% 50%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: relative;
  transition: all 1s;
  content: '';
  .content {
    background: rgba(0, 0, 0, 0.75);
    padding: 100px 0;
    text-align: center;
    * {
      margin: 0;
      padding: 0;
    }
    h1 {
      font-size: 45px;
      color: #fff;
    }
    p {
      color: rgb(197, 197, 255);
      font-weight: 700;
    }
  }
}
</style>
